import { createFileRoute } from '@tanstack/react-router'
import { ResellerWithdrawalsPage } from '@/features/reseller/pages/withdrawals'

export const Route = createFileRoute('/_authenticated/reseller/withdrawals')({
  component: ResellerWithdrawalsPage,
})

